import type { Project } from '@/types'

export const mockProjects: Project[] = [
  {
    id: 1,
    name: 'Legacy Banking Migration',
    description: 'QVS to Java transformation',
    progress: 70,
    status: 'Active',
    updatedAt: '2h ago',
    target: 'Java',
    files: 142,
    complexity: 'High',
  },
  {
    id: 2,
    name: 'E-commerce DB Migration',
    description: 'SQL Server → PostgreSQL',
    progress: 45,
    status: 'Active',
    updatedAt: '5h ago',
    target: 'PostgreSQL',
    files: 87,
    complexity: 'Medium',
  },
  {
    id: 3,
    name: 'Microservice Decomposition',
    description: 'Monolith to microservices',
    progress: 20,
    status: 'Active',
    updatedAt: '1d ago',
    target: 'Spring Boot',
    files: 320,
    complexity: 'Very High',
  },
  {
    id: 4,
    name: 'Python 2 Upgrade',
    description: 'Python 2.7 → Python 3.11',
    progress: 90,
    status: 'Active',
    updatedAt: '30m ago',
    target: 'Python 3',
    files: 56,
    complexity: 'Low',
  },
  {
    id: 5,
    name: 'Angular to React',
    description: 'Frontend framework migration',
    progress: 55,
    status: 'Active',
    updatedAt: '3h ago',
    target: 'React',
    files: 203,
    complexity: 'Medium',
  },
]
